module.exports = __webpack_public_path__ + "static/media/icon-medium.b7302dde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-medium.svg
// module id = 512
// module chunks = 0